import { isUser } from 'src/common/utils/guideItemTypes';

export const FETCH_MORE_ITEMS = 'FETCH_MORE_ITEMS';

const requestTypeEndpointMap = {
  Browse: 'browse.getItems',
  Profile: 'profile.getV3',
  Search: 'profile.search',
};

export function apiResponseTransform(response) {
  return {
    auth: response.auth,
    content: {
      guideItems: response.data.items,
      containerNavigation: response.data.paging,
    },
  };
}

export function fetchMoreItems(requestParams) {
  const {
    selectedContentId,
    containerNavigation,
    containerIndex,
    offset,
    limit,
  } = requestParams;
  const { destinationInfo } = containerNavigation;

  const endpoint =
    destinationInfo.id &&
    (isUser(destinationInfo.id) || destinationInfo.id === 'me') // HACK FIXME
      ? 'profile.userById'
      : requestTypeEndpointMap[destinationInfo.requestType];

  const apiParams = {
    ...destinationInfo.attributes,
    // needed due to inconsistencies with how API returns itemToken property
    itemToken:
      containerNavigation.itemToken || containerNavigation.context.itemToken,
    offset,
    limit,
  };

  return {
    type: FETCH_MORE_ITEMS,
    api: {
      endpoint,
      args: [destinationInfo.id, apiParams],
      transform: apiResponseTransform,
    },
    meta: {
      contentId: selectedContentId,
      containerIndex,
    },
  };
}
